export default "__VITE_ASSET__Bvf8XJs6__"